/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ step: NonNullable<unknown>, total: NonNullable<unknown> }} Auth_Signup_Step_OfInputs */

const cs_auth_signup_step_of = /** @type {(inputs: Auth_Signup_Step_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Krok ${i?.step} z ${i?.total}`)
};

const en_auth_signup_step_of = /** @type {(inputs: Auth_Signup_Step_OfInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Step ${i?.step} of ${i?.total}`)
};

/**
* | output |
* | --- |
* | "Step {step} of {total}" |
*
* @param {Auth_Signup_Step_OfInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_step_of = /** @type {((inputs: Auth_Signup_Step_OfInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Step_OfInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_step_of(inputs)
	return cs_auth_signup_step_of(inputs)
});